import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Triangle from 'assets/images/triangle.svg';

const StyledLink = styled.div`
  position: fixed;
  bottom: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  background: hsla(360, 100%, 100%, 0.5);
  border: 1px solid ${({ theme }) => theme.color.second};
  border-radius: 50px;
  cursor: pointer;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visibile' : 'hidden')};
  transition: all 0.8s ease-in-out;
`;

const StyledTriangle = styled(Triangle)`
  position: absolute;
  right: 12px;
  bottom: 14px;
`;

const BotomButton = ({ isVisible, goOnTop }) => {
  return (
    <StyledLink
      onClick={goOnTop}
      isVisible={isVisible}
      aria-label="powrót do góry"
    >
      <StyledTriangle />
    </StyledLink>
  );
};

BotomButton.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  goOnTop: PropTypes.func.isRequired,
};

export default BotomButton;
